import { AxiosPromise } from 'axios';
import { ConfigSettingsResultType } from 'src/app/services/config-settings/config-settings.service.type';
import { axios } from 'src/app/utils';
import { finalUrlsConfig } from 'src/configs/url.config';

export const getConfigSettings = (): AxiosPromise<ConfigSettingsResultType> => {
  return axios.get(finalUrlsConfig().configSettings.lookup);
};

export const updateAndCreateConfigSettings = (data: any): AxiosPromise<ConfigSettingsResultType> => {
  return axios.patch(finalUrlsConfig().configSettings.create, data);
};
